// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"876":"f3e6622a","924":"f855d7da"}[chunkId] + ".chunk.css";
};